import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import DesktopTabsForScheduledClasses from "./DesktopTabsforSchduleClasses/DesktopTopTabsForScheduleClasses";
import { CreateScheduleA, GetClassScheduleA, GetStudentAllCoursesScheduleA, GetUserByIdA } from "../../Actions/StudentA";
import { GetAboutInfoA, GetInstituteCoursesTimeSlots } from "../../Actions/CourseA";
import { BaseUrl } from "../../Actions/Base";
import { GetInstituteSideCoursesTimeSlots } from "../../Actions/CourseA";
import AboutClient from "./AboutClient/AboutClient";
import ScheduleAndInstructorTab from "./ScheduleAndInstructorTab/ScheduleAndInstructorTab";
import { GetCourseInstructorA, GetInstructorsA } from "../../Actions/InstructorA";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import axios from "axios";

const ManageNewStudentChild= () => {
    const Dispatch = useDispatch();
       
    const [activeTab, setActiveTab] = useState("AboutClient");
    const { EnrollmentId } = useParams();
    const { Student, ScheduleTimeTable, loading, CoursePackage, StudentInfo, StudentAllCoursesSchedule } = useSelector(
        (Store) => Store.StudentReducer
      );
    const { Instructors, CourseInstructors } = useSelector(Store => Store.InstructorReducer)
    const { timeSlots } = useSelector((Store) => Store.CourseReducer);
    const [allInstructorsScheduledClasses, setAllInstructorsScheduledClasses] = useState([]);

    console.log("Institute Training timeslots are:",timeSlots)
    
    console.log("ScheduleTimeTable", ScheduleTimeTable)
    console.log("Student", Student);
    console.log("CoursePackage", CoursePackage);
    console.log("StudentInfo", StudentInfo);
    console.log("CourseInstructorsss", CourseInstructors)
    console.log("StudentAllCoursesSchedule", StudentAllCoursesSchedule)

    const InstituteCourseId = StudentInfo?.InstituteCourseFK;
    const StudentId = Student?.UserId;
    console.log("StudentId", StudentId)

    useEffect(() => {
        if (EnrollmentId) {
            Dispatch(GetClassScheduleA(EnrollmentId)); 
            Dispatch(GetAboutInfoA(EnrollmentId)); 
            Dispatch(GetInstructorsA(EnrollmentId))
            Dispatch(GetCourseInstructorA(EnrollmentId))
        }
      }, [Dispatch, EnrollmentId]); // Add `userId` if it's used in the effect

    useEffect(() => {
        if (InstituteCourseId) {
            Dispatch(GetInstituteCoursesTimeSlots(InstituteCourseId)); // Pass the state
        }
      }, [Dispatch, InstituteCourseId]); // Add `userId` if it's used in the effect

    useEffect(() => {
      if (StudentId) {
          Dispatch(GetStudentAllCoursesScheduleA(StudentId)); // Pass the state
      }
    }, [Dispatch, StudentId]); // Add `userId` if it's used in the effect


    useEffect(() => {
      const fetchAllInstructorSchedules = async () => {
        try {
          const instructorIds = CourseInstructors?.map(
            (instructor) => instructor?.Instructor?.InstructorId
          ).filter(Boolean); // remove null/undefined
    
          if (!instructorIds.length) return;
    
          const schedulePromises = instructorIds.map((id) =>
            axios.get(`/api/teacher/schedule/${id}`)
          );
    
          const responses = await Promise.all(schedulePromises);
          console.log("responses in fetchAllInstructorSchedules are:", responses)

          // Merge and transform all data
          const allTransformedSchedules = responses.flatMap((response, index) => {
            const data = response.data;
            if (!Array.isArray(data) || data.length === 0) return [];
    
            return data.map((item, i) => ({
              Id: item.EventId || `${index}-${i}`,
              Subject: item.ClassType,
              StartTime: new Date(item.startDate),
              EndTime: new Date(item.endDate),
              CategoryColor: '#FF52C5',
              InstructorName: item.InstructorName,
              InstructorId: item.InstructorFK,
              StudentName: `${item?.CourseEnrollment?.User?.FirstName ?? ''} ${item?.CourseEnrollment?.User?.LastName ?? ''}`,
              ClassType: item.ClassType,
            }));
          });
    
          setAllInstructorsScheduledClasses(allTransformedSchedules);
        } catch (error) {
          console.error("Error fetching instructor schedules:", error);
        }
      };
      if (CourseInstructors) {
        fetchAllInstructorSchedules();
      }
    }, [CourseInstructors]); // Empty dependency → runs once on mount
    

     // Function to render the right-side content based on the active tab
    const renderContent = () => {
         switch (activeTab) {
            case "AboutClient":
                  return <AboutClient Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab} />;
            case "ScheduleAndInstructor":
                  return <ScheduleAndInstructorTab Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab}
                   CourseInstructors={CourseInstructors} ScheduleTimeTable={ScheduleTimeTable} CoursePackage={CoursePackage} EnrollmentId={EnrollmentId}
                   timeSlots={timeSlots} allInstructorsScheduledClasses={allInstructorsScheduledClasses} StudentAllCoursesSchedule={StudentAllCoursesSchedule} /> ;
            default:
             return <AboutClient Student={Student} StudentInfo={StudentInfo} setActiveTab={setActiveTab} />;
         }
     };
    
    return (
        <>
         {!loading ? (
              <>
                <DesktopTabsForScheduledClasses setActiveTab={setActiveTab} activeTab={activeTab} CoursePackage={CoursePackage} />
                <div className="mt-[50px] pb-[100px]">
                    {renderContent()}
                </div>
              </>
         ) :  (
              <LoadingSpinner
              Height="[500px]"
              Width="[99%]"
              Top="[80px]"
              Left="0"
              Position="relative"
            />
         )}
        </>
    );
};


const SchedulingNewStudentClasses = () => (
    <InstituteTemplate
      Element={ManageNewStudentChild}
      m_top="mt-0"
      bg="bg-[#F0F0F7]"
    />
  );

export default SchedulingNewStudentClasses;
